import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components';
import { FLUID, MODERN_CLASSIC } from '../../../../../../constants/pageSets';
import classes from './PageSetPicker.scss';

function pageSetClassName(pageSet) {
  switch (pageSet) {
    case FLUID:
      return classes.fluid;

    case MODERN_CLASSIC:
      return classes.modernClassic;

    default:
      return '';
  }
}

function pageSetName(pageSet) {
  switch (pageSet) {
    case FLUID:
      return 'Fluid';

    case MODERN_CLASSIC:
      return 'Modern Classic';

    default:
      return '';
  }
}

export default class PageSet extends React.PureComponent {
  static propTypes = {
    pageSet: PropTypes.oneOf([
      FLUID,
      MODERN_CLASSIC,
    ]).isRequired,
    onSelect: PropTypes.func.isRequired,
    selected: PropTypes.bool,
  };

  static defaultProps = {
    selected: false,
  };

  handleSelect = () => {
    const { pageSet, onSelect } = this.props;

    onSelect(pageSet);
  };

  render() {
    const { pageSet, selected } = this.props;

    return (
      <div className={classes.setContainer}>
        <div
          className={[
            classes.pageSet,
            pageSetClassName(pageSet),
            selected ? classes.active : null,
          ].filter(Boolean).join(' ')}
          onClick={this.handleSelect}
        >
          <div className={classes.overlay}>
            {selected ? (
              <Icon icon="success" />
            ) : 'Select Page Set'}
          </div>
        </div>
        <div className={classes.label}>
          {pageSetName(pageSet)}
        </div>
      </div>
    );
  }
}
